import * as $ from "jquery";
import { ConsentHubClient } from "../common/ConsentHubV2";
import Environment from "../common/environment";
import _ from "underscore";
import Hamlet from "./modules/hamlet";
import Cofs from "./modules/cofs";
import CloudGrowthTracker from "./modules/growth-tracker";
import Experiments from "./modules/experiments";
import PasswordStrength from "./modules/passwordstrength";
import SocialLogin from "./modules/social-login";
import CombinedBundles from "./modules/combined-bundles";
import Tracking from "../common/tracking";
import { GASv2, GoogleAnalytics, Segment } from "../common/tracking/platforms";
import OriginTracing from "@atlassiansox/origin-tracing";
import retry from "async-retry";
import onThrottled from "../utils/event";
import imkt from '../imkt';
import storage from "../utils/storage";
import tracking from '../utils/tracking';
import url from '../utils/url';

var FORCE_RECAPTCHA_COOKIE = "bxp.force.captcha";
var MICROSOFT_SIGN_UP_EXPERIMENT_COOKIE = "NUXAPOLLO-257";

var CONFLUENCE_ACCOUNT_SETUP_EXPERIMENT_COOKIE = "NUXAPOLLO-210";
var CONFLUENCE_PRODUCT_KEY = "confluence.ondemand";
const RESEND_DATA = "r.e.d";

imkt.cx = imkt.cx || {};

const performanceStartTime = performance.now();

// used for tracking purposes
var captchaFilled = false;

imkt.cx.FormCloudSignup = class FormCloudSignup {
  PRODUCTS_STORAGE_KEY: string;
  URL_CONFIRMATION_PATH: string;
  URL_CHECKEMAIL_PATH: string;
  URL_BUY_SIGNUP_PATH: string;
  URL_ACCOUNT_SETUP_PATH: string;
  STATUS_PROCESSING_COMPLETE_REVIEW_REQUIRED: string;
  STATUS_PROCESSING_COMPLETE: string;
  STATUS_INCOMPLETE: string;
  STATUS_ERROR: string;
  ERROR_CLASS: string;
  isDeveloper: boolean;
  $domRoot: JQuery<HTMLElement>;
  params: any;
  labels: any;
  baseDomain: string;
  useGDPR: any;
  opsgenieSignupIsActive: boolean;
  availableProducts: any;
  possiblyPremium: any;
  products: any;
  isBundle: any;
  bundleData: any;
  trialBundleData: any;
  useAlternateLayout: boolean;
  consentLabelMarketing: any;
  baseIdDomain: any;
  templateId: any;
  formData: {};
  userSubmittedWithCaptcha: boolean;
  features: {
    allowCoupon: any; allowBitbucket: any; allowDeveloperMode: any; recaptcha: boolean; simpleForm: any;
    /* Enforce Captcha for all forms */
    invisibleRecaptcha: boolean; enableAutogenSiteName: boolean; performanceBoost: any; enableContinueWithGoogle: any; enableContinueWithMicrosoft: boolean; enableFirstImpressions: any; enableCombinedBundles: boolean; enableConfluenceAccountSetup: boolean; allowResendVerificationEmail: any; enableAisAvailableProducts: any;
  };
  availableEditions: { standard: string; premium: string; free: string; };
  edition: null;
  migrationSourceUuid: null;
  simplifiedSiteSelected: string;
  user: null;
  accounts: never[];
  simpleFormAdminPath: any;
  simpleFormExperienceVersion: any;
  coupon: boolean;
  useSocialLogin: boolean;
  consentHub: ConsentHubClient;
  environment: string;
  loginOrigin: OriginTracing;
  switchOrigin: OriginTracing;
  experiments: Experiments;
  hamlet: Hamlet;
  cofs: Cofs;
  growthTracker: CloudGrowthTracker;
  pw: PasswordStrength;
  socialLogin: SocialLogin;
  combinedBundles: CombinedBundles;
  developerWarning: any;
  selectedProducts: never[];
  selectedAddons: never[];
  hamletProducts: never[];
  hamletCoreProducts: never[];
  hamletAddonProducts: never[];
  consentConfig: { locale: string; localeRequiresMarketingCommunicationOptIn: boolean; };
  productKeys: any;
  form: any;
  captchaContainer: any;
  showBundle: any;
  activeBundle: null;
  cofsListContainer: JQuery<HTMLElement>;
  fields: JQuery<HTMLElement>;
  emailField: any;
  accountNameField: any;
  firstNameField: any;
  lastNameField: any;
  passwordField: any;
  showPasswordField: any;
  submitButton: any;
  timeoutWarnings: JQuery<HTMLElement>;
  passwordScoreTemplateTarget: any;
  marketingConsentContainer: any;
  eulaContainer: any;
  annualSubscriptionContent: JQuery<HTMLElement>;
  linkLoginUser: any;
  linkExistingUser: any;
  dataRegionField: any;
  
  constructor(domRoot: HTMLElement, params: any) {
    this.PRODUCTS_STORAGE_KEY = "wac_cofs_products";
    this.URL_CONFIRMATION_PATH = "/ondemand/signup/confirmation";
    this.URL_CHECKEMAIL_PATH = "/ondemand/signup/checkemail";
    this.URL_BUY_SIGNUP_PATH = "/buy/signup";
    this.URL_ACCOUNT_SETUP_PATH = "/signup/account/setup";

    this.STATUS_PROCESSING_COMPLETE_REVIEW_REQUIRED =
      "PROCESSING_COMPLETE_REVIEW_REQUIRED";
    this.STATUS_PROCESSING_COMPLETE = "PROCESSING_COMPLETE";
    this.STATUS_INCOMPLETE = "INCOMPLETE";
    this.STATUS_ERROR = "ERROR";
    this.ERROR_CLASS = "has-error";

    // Is a developer account for the Ecosystem developer signup flow
    this.isDeveloper = false;

    this.$domRoot = $(domRoot);
    this.params = params;
    this.labels = this.params.labels || {};

    // Set WAC Base domain
    this.baseDomain = Environment.getWacIntegrationUrl();

    // GDPR Enabled
    this.useGDPR = this.params.useGDPR;

    // Opsgenie
    this.opsgenieSignupIsActive = false;

    // Identify products
    this.availableProducts = this.params.availableProducts || [];
    this.possiblyPremium = this.availableProducts.some(
      (product) => product.premium_enabled === true
    );
    this.products = this.params.products || "";
    this.isBundle = this.params.isBundle || false;
    this.bundleData = this.params.bundleData;

    // Use Alternate Layout if enabled in params
    this.trialBundleData = this.params.trialBundle || null;
    this.useAlternateLayout =
      this.trialBundleData && this.trialBundleData.useTrialInfo ? true : false;

    this.consentLabelMarketing = this.params.consentLabelMarketing;

    // Id base per environment
    this.baseIdDomain = this.params.baseIdDomain || "https://id.atlassian.com";

    // Template ID
    this.templateId = this.params.templateId || this.getTemplateFromUrl();

    this.formData = {};

    this.userSubmittedWithCaptcha = false;
    this.features = {
      allowCoupon: this.params.allowCoupon || false,
      allowBitbucket: this.params.allowBitbucket || false,
      allowDeveloperMode: this.params.allowDeveloperMode || false,
      recaptcha: !!(
        this.params.allowCaptcha &&
        (Environment.isProduction() ||
          storage.getCookie(FORCE_RECAPTCHA_COOKIE) !== null)
      ),
      simpleForm: this.params.allowSimpleForm || false,
      /* Enforce Captcha for all forms */
      invisibleRecaptcha: true,
      enableAutogenSiteName: !!this.params.allowEnableAutogenSiteName,
      performanceBoost: this.params.allowPerformanceBoost || false,
      enableContinueWithGoogle:
        this.params.allowEnableContinueWithGoogle || false,
      enableContinueWithMicrosoft: !!(
        this.params.allowEnableContinueWithMicrosoft &&
        storage.getCookie(MICROSOFT_SIGN_UP_EXPERIMENT_COOKIE) !== null
      ),
      enableFirstImpressions: this.params.allowFirstImpressions || false,
      enableCombinedBundles: !!this.params.allowCombinedBundles,
      enableConfluenceAccountSetup: !!(
        this.params.allowConfluenceAccountSetup &&
        storage.getCookie(
          CONFLUENCE_ACCOUNT_SETUP_EXPERIMENT_COOKIE
        ) !== null
      ),
      allowResendVerificationEmail:
        this.params.allowResendVerificationEmail || false,
      enableAisAvailableProducts: this.params.enableAisAvailableProducts || false,
    };

    this.availableEditions = {
      standard: "standard",
      premium: "premium",
      free: "free",
    };
    this.edition = null;

    this.migrationSourceUuid = null;

    this.simplifiedSiteSelected = "";
    this.user = null;
    this.accounts = [];
    this.simpleFormAdminPath = (this.params.simpleFormAdminPath || "").trim();
    this.simpleFormExperienceVersion = (
      this.params.simpleFormExperienceVersion || ""
    ).trim();
    this.coupon = false;
    this.useSocialLogin = false;

    this.consentHub = new ConsentHubClient();

    this.environment = Environment.getEnvironment();

    // Origin IDs
    this.loginOrigin = new OriginTracing({ product: "wac-signup-login" });
    this.switchOrigin = new OriginTracing({ product: "wac-signup-switch" });

    // Initialize Component
    this.init();
  }

  async init() {
    // Switch on WCF-459
    if (this.useAlternateLayout) {
      this.activateFormVariation();
    }

    // Cache dom queries for elements
    this.bindElements();

    // Update id urls for existing email accounts
    this.updateIdUrls();

    // Update for i18n tranlsated text
    this.updateLocaleText();

    this.updateFormReady();

    if (!this.features.simpleForm) {
      $(".icon--cohort-pending").remove();
      this.$domRoot.find(".cohort-pending").removeClass("cohort-pending");
    }

    // Initialize base modules
    this.experiments = new Experiments(storage, _);
    this.hamlet = new Hamlet();
    this.cofs = new Cofs(
      this.baseDomain,
      this.params.baseCofsPath,
      this.hamlet,
      $,
      this.experiments,
      this.environment
    );
    this.growthTracker = new CloudGrowthTracker();
    this.pw = new PasswordStrength();
    this.socialLogin = new SocialLogin(
      this.baseDomain,
      this.baseIdDomain,
      this.hamlet,
      $,
      imkt.utils,
      this.getLocaleParam(),
      this.params.urlRenameSitePath
    );
    this.combinedBundles = new CombinedBundles($);
    this.cofs.init();
    this.pw.init();
    this.experiments.init();
    this.socialLogin.init();

    // Enable Developer signup flow for Atlassian Connect devs
    if (this.features.allowDeveloperMode) {
      this.isDeveloper = !!(url.getUrlParams() || {}).developer;
      if (this.isDeveloper) {
        this.experiments.setExperimentKey("PUR-7747");
        this.developerWarning.show().removeClass("hide-all, display-none");
      }
    }

    // Initialize Products
    this.selectedProducts = [];
    this.selectedAddons = [];
    this.hamletProducts = [];
    this.hamletCoreProducts = [];
    this.hamletAddonProducts = [];

    //Disable invisible recaptcha
    window.addEventListener("DOMContentLoaded", () => {
      this.disableSubmitButton(true);
    });
    window.onbeforeunload = (e) => {
      const eventLabel = "form event";
      try {
        //if the user leaves the page before the hamlet call was completed, the event will be fired with isExistingUser = false
        const isExistingUser = this.hamlet.isLoggedIn();
        let properties = {
          existingUser: isExistingUser,
          firstNameFilled: Boolean(e.target.querySelector("#firstName").value),
          lastNameFilled: Boolean(e.target.querySelector("#lastName").value),
          emailFilled: isExistingUser
            ? true
            : Boolean(e.target.querySelector("#email").value),
          passwordFilled: isExistingUser
            ? false
            : Boolean(e.target.querySelector("#aod-password").value),
          siteNameFilled: Boolean(e.target.querySelector("#accountName").value),
          reCaptchaFilled: captchaFilled,
        };
        if (Environment.isProduction())
          this.fireBeaconAnalyticsEvent(properties, false);
        Tracking.trackAll(
          "cart-cloud",
          "Page unload",
          eventLabel,
          properties,
          false
        );
      } catch (e) {
        if (Environment.isProduction()) this.fireBeaconAnalyticsEvent({}, true);
        Tracking.trackAll(
          "cart-cloud",
          "Page unload error",
          eventLabel,
          {},
          false
        );
      }
    };

    // Check for GDPR locale
    if (this.params.useGDPR) {
      // default config
      this.consentConfig = {
        locale: "UNKNOWN",
        localeRequiresMarketingCommunicationOptIn: true,
      };

      // get/request config from ConsentHub
      this.consentHub = new ConsentHubClient();
      try {
        this.consentConfig = await this.consentHub.requestConfig();
      } catch (_error) {
        Tracking.trackAll(
          "cart-cloud",
          "ConsentHub config request error",
          "cloud",
          {},
          false
        );
      }

      this.renderMarketingConsent(
        this.consentConfig.localeRequiresMarketingCommunicationOptIn,
        this.consentLabelMarketing
      );
    }

    if (this.features.allowCoupon) {
      this.checkUrlCouponKey();
    }

    if (this.features.recaptcha) {
      $(document).on("ReCaptchaReady", () => this.renderCaptcha());
    }

    if (this.features.invisibleRecaptcha) {
      $(document).on("InvReCaptchaReady", () => this.renderInvCaptcha());
      $(document).on("recaptchaApproved", () => {
        this.submitHandler();
      });
    }

    this.hamlet
      .identifyProducts()
      .then(() => {
        this.setProducts();
        this.renderProductSelections();
        this.initUser();
      })
      .catch(() => {
        this.setProducts();
        this.renderProductSelections();
        this.initUser();
      });
  }

  initUser() {
    var self = this;

    this.hamlet
      .init(this.features.performanceBoost)
      .then(() => {
        if (!this.migrationSourceUuid) {
          return Promise.resolve();
        }
        // If migrationSourceUuid is set, we need to check in HAMLET which of the user sites
        // is eligible for it.
        const productKey = this.productKeys[0]; // ECTL is allowed only if one prod is set
        const cloudIds = this.hamlet.getSites().map((site) => site.cloudId);
        return this.hamlet.checkExtendedTrialAvailability(
          this.migrationSourceUuid,
          productKey,
          cloudIds
        );
      })
      .then(() => this.hamlet.getUser())
      .then((user) => {
        if (this.migrationSourceUuid) {
          const extendedTrialAvailability =
            this.hamlet.getExtendedTrialAvailability();
          if (extendedTrialAvailability) {
            this.renderExtendedTrialBullets(
              extendedTrialAvailability.usageLimit,
              extendedTrialAvailability.usageType
            );
            const status = extendedTrialAvailability.cloudCreation;
            if (!status.available) {
              return this.renderExtendedTrialError(status.reason);
            }
          } else {
            return this.renderExtendedTrialError();
          }
        }

        if (
          this.socialLogin.detectSocialLoginPage() &&
          !this.socialLogin.isValidSocialLoginUser(user)
        ) {
          // User is on signup-social-login page with invalid user details
          window.location.replace(this.socialLogin.getWacTryCloudSignupUrl());
          return;
        }

        if (this.hamlet.isLoggedIn()) {
          /**
           * NUXAPOLLO-611 redirect user back to sign up page if user is logged in
           */
          if (this.features.enableCombinedBundles) {
            window.location.href = "/try/cloud/signup" + window.location.search;
            Tracking.trackAll(
              "cart-cloud",
              "Logged-In User Redirect",
              "combined-bundles-signup-page",
              { existingUser: true },
              true
            );
          }

          self.user = user;
          const newUsersOnlyRestriction =
            this.productKeys.indexOf("com.atlassian.bitbucket") !== -1
              ? true
              : false;
          const existingUserCloudData = {};
          const isSocialLogin = this.socialLogin.isSocialLogin(
            user,
            this.productKeys,
            newUsersOnlyRestriction,
            existingUserCloudData
          );
          if (isSocialLogin) {
            if (existingUserCloudData.cloudDetails) {
              // Back to this signup social login page using the same account,
              // should proceed to rename site or account setup page directly.
              if (this.features.enableConfluenceAccountSetup) {
                this.goToAccountSetup(
                  existingUserCloudData.cloudDetails.cloudId,
                  existingUserCloudData.cloudDetails.requestId,
                  existingUserCloudData.cloudDetails.cloudName
                );
              } else {
                window.location.replace(
                  this.socialLogin.getRenameSiteUrl(
                    existingUserCloudData.cloudDetails
                  )
                );
              }
            } else {
              this.continueWithSocialLogin(user);
            }
          } else {
            if (newUsersOnlyRestriction) {
              // BB can only handle new users for now, not existing users that
              // might already have BB, JSW or both.
              const products = this.productKeys
                .join(",")
                .replace("com.atlassian.bitbucket", "bitbucket.ondemand");
              const url =
                this.baseDomain +
                this.URL_BUY_SIGNUP_PATH +
                "?product=" +
                products;
              window.location = url;
            } else {
              this.formRenderLoggedIn(user);
            }
          }
        } else {
          self.user = null;
          this.formRenderLoggedOut();
        }
        this.updateSignupDomainLabels();
      })
      .catch(() => {
        if (this.socialLogin.detectSocialLoginPage()) {
          this.socialLogin.showSocialLoginError("init-user-error");
        } else {
          this.formRenderLoggedOut();
          this.updateSignupDomainLabels();
        }
      });
  }

  /**
   * Continue with social login
   */
  continueWithSocialLogin(user) {
    this.useSocialLogin = true;
    this.socialLogin.showPreparingCloudMessage();

    // Populate form data
    this.formData["email"] = user.myDetails.email;
    this.formData["firstName"] = user.myDetails.firstName;
    this.formData["lastName"] = user.myDetails.lastName;
    this.formData["productKeys"] = this.productKeys;
    this.submitCloud();
  }

  /**
   * On successful cloud creation, redirect to rename site page
   */
  goToRenameSite({ progressUri, cloudId, cloudName = "" }) {
    if (!progressUri) {
      console.error("undefined progressUri");
      return;
    }

    try {
      // Send finish analytics
      const trackingProps = {
        value: cloudId,
        isSocialLogin: this.useSocialLogin,
        isRecaptchaV2: this.features.recaptcha,
        isInvisibleRecaptcha: this.features.invisibleRecaptcha,
        existingUser: this.hamlet.isLoggedIn(),
      };
      Tracking.trackAll(
        "cart-cloud",
        "Completed Checkout Step",
        "complete-signup-page",
        trackingProps,
        true
      );
      this.trackAnalyticsProduct(
        0,
        "Confirmed Evaluation",
        "cart-cloud.confirmed-evaluation."
      );
      this.growthTracker.sendTrack("navigatedToRenameSite");
      // eslint-disable-next-line no-empty
    } catch (e) { }

    // Redirect to rename site
    const requestId = this.cofs.getRequestId(progressUri);
    const cloudDetails = {
      cloudId,
      cloudName,
      requestId,
      productKeys: this.productKeys,
    };

    // NUXAPOLLO-510 check if the user is permitted to rename the site before redirecting the user to the rename site page
    this.checkPerms(cloudId)
      .then((res) => {
        cloudDetails.isPermitted = res.permitted;
        Tracking.trackAll(
          "cart-cloud",
          "Completed permissions check",
          "complete-social-signup-page",
          {
            cloudId,
            status: 200,
            permitted: res.permitted,
          },
          true
        );
        window.location.replace(
          this.socialLogin.getRenameSiteUrl(cloudDetails)
        );
      })
      .catch((e) => {
        cloudDetails.isPermitted = false;
        Tracking.trackAll(
          "cart-cloud",
          "Failed permissions check",
          "complete-social-signup-page",
          {
            cloudId,
            message: e.message,
          },
          true
        );
        window.location.replace(
          this.socialLogin.getRenameSiteUrl(cloudDetails)
        );
      });
  }

  setResendEmailParams(cloudId, requestId, autoGeneratedCloudName) {
    if (
      this.features.allowResendVerificationEmail &&
      !this.opsgenieSignupIsActive
    ) {
      try {
        var data = sessionStorage.getItem(RESEND_DATA)
          ? JSON.parse(sessionStorage.getItem(RESEND_DATA))
          : {};
        if (this.formData.email) {
          data["email"] = this.formData.email;
        }
        if (cloudId && requestId) {
          data["cloudId"] = cloudId;
          data["requestId"] = requestId;
        }
        if (autoGeneratedCloudName) {
          data["cloudName"] = autoGeneratedCloudName;
        }
        sessionStorage.setItem(RESEND_DATA, window.btoa(JSON.stringify(data)));
      } catch (e) {
        sessionStorage.removeItem(RESEND_DATA);
      }
    } else {
      sessionStorage.removeItem(RESEND_DATA);
    }
  }

  fireBeaconAnalyticsEvent(data, error) {
    if (typeof ace !== "undefined") {
      ace.analytics.Tracking.trackUnloadEvent(
        error ? "unload beacon error" : "unload beacon",
        data
      );
    }
  }

  activateFormVariation() {
    this.reorderFormFields();

    // to be deprecated with an event emitted in wrapper when segment is available
    window.segmentPageReady = function () {
      tracking.trackEvent("wcf-459-signup-shown", {});
    };
  }

  reorderFormFields() {
    const emailField = $(this.params.fieldIds.emailId);
    const passwordField = $(this.params.fieldIds.passwordId);
    const fullnameField = $(this.params.fieldIds.fullnameId);
    const sitenameField = $(this.params.fieldIds.sitenameId);
    const dataRegionFieldContainer = $(this.params.fieldIds.dataRegionId);

    const sitenameLoadingIcon = sitenameField.find("span.loading").first();
    const sitenameValidationIcon = sitenameField
      .find("span.validation-success")
      .first();
    const signupDomainSpan = sitenameField.find("span.signup-domain").first();

    const greeting = $(
      `<div class="h4">${this.params.trialBundle.signupFormGreeting}</div>`
    );

    emailField.insertBefore(sitenameField);
    passwordField.insertBefore(sitenameField);
    fullnameField.insertBefore(sitenameField);
    dataRegionFieldContainer.insertBefore(sitenameField);

    // Add first and last name labels instead of full name
    fullnameField.find('label[for="firstName"]').remove();
    fullnameField
      .find(".half.left")
      .prepend(
        `<label for="firstName">${this.params.altLabels.firstNameLabel} </label>`
      );
    fullnameField
      .find(".half.right")
      .prepend(
        `<label for="lastName">${this.params.altLabels.lastNameLabel} </label>`
      );

    // Add greeting and post submit text
    greeting.insertBefore(emailField);

    // Update site name label
    sitenameField
      .find('label[for="accountName"] > span')
      .text(this.params.altLabels.siteNameLabel);

    // move site name loading and validation success icons after signup domain span
    sitenameLoadingIcon.remove();
    sitenameValidationIcon.remove();
    signupDomainSpan.after([sitenameLoadingIcon, sitenameValidationIcon]);

    // fix tabs after reordering
    emailField.find("input").attr("tabindex", "0");
    passwordField.find("input").attr("tabindex", "0");
    fullnameField.find("input").attr("tabindex", "0");
    sitenameField.find("input").attr("tabindex", "0");
    passwordField.find("input[type=checkbox]").attr("tabindex", "-1");

    this.changeSiteNameVisibility();
  }

  changeSiteNameVisibility() {
    const sitenameField = $(this.params.fieldIds.sitenameId);
    if (this.features.enableAutogenSiteName) {
      sitenameField.css("display", "none");
      sitenameField.attr("aria-hidden", true);

      // the sitename field is still required. adding a value to the field will ensure that we pass form validation.
      sitenameField.find("input").val("nuxsignup-default");
    } else {
      sitenameField.removeAttr("style");
      sitenameField.removeAttr("aria-hidden");
      sitenameField.find("input").val("");
    }
  }

  // First Impression UI changes
  enableFirstImpression() {
    const self = this;

    // class changes
    $(".imkt--cloud-signup").addClass("firstimpression");
    $(".column--cloud-signup-bundle").addClass("firstimpression");
    $(".with-bundle").addClass("firstimpression");
    $(".trial-info-data__features").addClass("firstimpression");
    $(".trial-info-data__download").addClass("firstimpression");
    $(".heading--products--hide").addClass("firstimpression");
    $(".row").removeClass("reduced-row");

    // css changes
    $(".imkt--cloud-signup").css("background-color", "transparent");
    $("#invisible_recaptcha_text").css("margin-top", "0px");
    //$(".already-sign-in").css("display", "block");
    $(".firstimpression-right").css("display", "block");
    $(".firstimpression-left").css("display", "none");
    $(".firstimpression-left-img").css("display", "block");
    $(".post-submit-text").css("display", "none");

    // html changes
    //$(".trial-info-data__features-heading").html("Free 7 Day Trial - No Credit Card");
    $(".trial-info-data__features ul li:nth-child(2)").html(
      "No credit card needed"
    );
    $(".trial-info-data__features ul li:nth-child(4)").html(
      "Access to support"
    );

    // metrics
    const signinLink = $(".already-sign-in").find("p a:first");
    if (signinLink) {
      // update url with OriginTracing
      signinLink.attr("href", this.getIdSigninAccountUrl());

      signinLink.on("click", function () {
        // publish metrics events
        try {
          Tracking.trackAll(
            "cart-cloud",
            "Clicked Existing User Sign In",
            "first-impressions-signup-page",
            { existingUser: self.hamlet.isLoggedIn() },
            false
          );
          tracking.trackEvent(
            "wac-signup-first-impressions-existing-user-signin",
            self.loginOrigin.toAnalyticsAttributes({ hasGeneratedId: true })
          );
        } catch (err) { }
      });
    }
  }

  getIdSigninAccountUrl() {
    const signinUrl = `${this.baseIdDomain}/login?`;
    const atlOrigin = `atlOrigin=${this.loginOrigin.encode()}`;
    return signinUrl + atlOrigin;
  }

  formRenderLoggedOut() {
    if (
      this.features.enableContinueWithGoogle ||
      this.features.enableContinueWithMicrosoft
    ) {
      this.socialLogin.renderSocialLogin({
        enableContinueWithGoogle: this.features.enableContinueWithGoogle,
        enableContinueWithMicrosoft: this.features.enableContinueWithMicrosoft,
        labels: this.labels,
        products: this.products,
        edition: this.edition,
      });
    }

    /**
     * NUXAPOLLO-611 enable combined bundles
     */
    if (this.features.enableCombinedBundles) {
      // enable first impression changes for UI backbone
      this.enableFirstImpression();

      // render UI changes for left form
      this.combinedBundles.renderCombinedBundlesForm();

      var _this = this;

      // define click event
      var combinedBundleProducts = $(".combined-bundle-products");

      $(combinedBundleProducts).click(function () {
        // update class
        $(combinedBundleProducts)
          .not(this)
          .each(function () {
            $(this).find(".custom-radio").removeClass("selected");
            $(this).removeClass("selected");
          });
        $(this).find(".custom-radio").addClass("selected");
        $(this).addClass("selected");

        // track click events for selectors
        try {
          Tracking.trackAll(
            "cart-cloud",
            "Clicked Bundle Selector",
            "combined-bundles-signup-page",
            { selectedBundle: $(this).attr("data-value") },
            false
          );
          // eslint-disable-next-line no-empty
        } catch (err) { }

        // rewrite url and reset product keys
        var newUrl =
          document.location.href.split("?")[0] +
          "?bundle=" +
          $(this).attr("data-value") +
          "&edition=free";
        history.replaceState(null, null, newUrl);

        //reset google login url
        $("#google-signup").prop(
          "href",
          _this.socialLogin.getContinueWithGoogleUrl()
        );

        //reset download link
        _this.combinedBundles.resetDownloadLink($(this).attr("data-value"));

        //reset log in url
        var loginUrl = _this.getLoginAccountUrl();
        $(".login-account-url").attr("href", loginUrl);

        // reset products before calling create cloud
        _this.setProducts();
      });
    }

    if (this.features.enableFirstImpressions) {
      // enable NUXAPOLLO-273 First Impression only for JSW and Logged Out users.
      this.enableFirstImpression();
    }

    $(".icon--cohort-pending").remove();
    this.$domRoot.find(".cohort-pending").removeClass("cohort-pending");
    this.growthTracker.sendTrack("onload.notloggedin");
    $(this.$domRoot)
      .find("label .icon--help")
      .mouseover(() => {
        Tracking.trackAll(
          "cart-cloud",
          "Tooltip displayed",
          "?",
          { labelContainer: "help", existingUser: false },
          false
        );
      });
    $("#host_on_server_link a").click((e) => {
      if (e.target.href.match(".*/download"))
        Tracking.trackAll(
          "cart-cloud",
          "Link clicked",
          "host this on your own server?",
          { labelContainer: "cloudSignupBundle", existingUser: false },
          false
        );
      var urlParams = new URLSearchParams(window.location.search);
      if (e.target.href.match(".*/pricing"))
        Tracking.trackAll(
          "cart-cloud",
          "Clicked Large Team Link",
          "buy for a large team?",
          { selectedBundle: urlParams.get("bundle") },
          false
        );
    });
    //add disableSubmitButton call here as the `g-recaptcha` in the submit button class enables it when page loads
    this.disableSubmitButton(true);
    this.formRenderReady();
  }

  renderExtendedTrialBullets(usageLimit, usageType) {
    const humanUsageType = (usageType) => {
      switch (usageType) {
        case "remote-agent-tier":
        case "bamboo-agent-tier":
        case "servicedesk-agent-tier":
          return "agents";
        default:
          return "users";
      }
    };
    const features = [
      ...this.selectedProducts.map(
        (product) => `Try ${product.name} cloud at no cost`
      ),
      ...(!!usageLimit && [`Up to ${usageLimit} ${humanUsageType(usageType)}`]),
      "No impact to your existing self-hosted products",
    ];
    $(".trial-info-data__features > ul", self.$domRoot).append(
      features.map((feature) => `<li>${feature}</li>`)
    );

    // Show the trial heading
    $(".trial-info-data__features-heading").addClass("active");
  }

  renderExtendedTrialError(reason: string) {
    $(".icon--cohort-pending").remove();
    this.$domRoot.find(".cohort-pending").removeClass("cohort-pending");
    this.form.hide();
    if (reason === "ALREADY_CLAIMED") {
      $(".extended-trial-error__claimed").show();
    } else {
      $(".extended-trial-error__invalid").show();
    }
  }

  //Set Invisible recaptcha for N2N if features.invisibleRecaptcha is enabled and disable recaptcha or N2E
  setInvisibleRecaptcha() {
    if (this.hamlet.isLoggedIn()) {
      $("#inv-recaptcha-signup_submit").hide();
      $("#invisible_recaptcha_text").hide();
      $("#signup_submit").show();
      this.features.recaptcha = false;
      this.captchaContainer.remove();
      this.features.invisibleRecaptcha = false;
    } else {
      if (this.features.invisibleRecaptcha) {
        $("#inv-recaptcha-signup_submit").show();
        $("#signup_submit").hide();
      } else {
        $("#inv-recaptcha-signup_submit").remove();
        $("#invisible_recaptcha_text").hide();
        $(".grecaptcha-badge").remove();
        $("#signup_submit").show();
      }
    }
    this.disableSubmitButton(true);
  }

  formRenderReady() {
    this.setInvisibleRecaptcha();
    // Bind User Interactions
    this.bindEvents();

    // Pass initial page view for custom tracking
    if (this.$domRoot.is(":visible")) {
      // Tracking used by Optimizely
      this.growthTracker.sendTrack("signup.init", {
        productCount: this.selectedProducts.length,
        referrer: document.referrer,
      });
      this.growthTracker.sendTrackVisitCounter("bxp_form_visit");

      const cartedProducts = this.products.split(",");
      const productAttributes = {
        cartedProducts,
        intendedProduct: cartedProducts[0],
      };
      Tracking.trackAll(
        "cart-cloud",
        "Viewed Checkout Step",
        "view-signup-page",
        productAttributes,
        true
      );
      this.trackAnalyticsProduct(
        0,
        "Added Product",
        "cart-cloud.added-product."
      );
    }

    // Show the trial duration now that we know the duration (logged in / logged out)
    $(".trial-info-data__features-heading").addClass("active");

    // Track the time from init to form ready state
    const performanceDuration = performance.now() - performanceStartTime;
    tracking.trackEvent("bxp.formCloudSignup.timeToFormReady", {
      performanceDuration: performanceDuration,
      performanceBoosted: this.features.performanceBoost,
      isLoggedIn: this.hamlet.isLoggedIn(),
    });
  }

  setProducts() {
    this.showBundle = this.params.showBundle || false;
    if (this.products && !this.showBundle) {
      this.productKeys =
        this.productKeys || _.without(this.products.split(","), "");
      this.assignSelectedProducts(this.productKeys);
      this.productKeys = _.uniq(this.productKeys);
      return;
    }

    this.hamletProducts = this.hamlet.getIdentifiedProducts();
    this.hamletCoreProducts = this.hamlet.getCoreProducts();
    this.hamletAddonProducts = this.hamlet.getAddons();

    this.activeBundle = null;
    if (this.showBundle) {
      if (!this.hamletProducts.length) {
        this.activeBundle = this.checkUrlBundleKey();
      } else {
        let productKeyMatch = _.pluck(
          this.hamletCoreProducts,
          "productKey"
        ).join(", ");
        this.activeBundle = this.findBundleWithProductsKeys(productKeyMatch);
      }

      this.activeBundle =
        this.activeBundle || this.params.bundleData["default"];
      this.products = this.activeBundle.bundleProductKeys || "";
      this.products = this.products.replace(/ /g, "");
    } else {
      this.products = _.pluck(this.hamletCoreProducts, "productKey").join(",");
    }

    this.productKeys =
      this.productKeys || _.without(this.products.split(","), "");

    /**
          NUXAPOLLO-611 reset product keys based on url
       */
    if (this.features.enableCombinedBundles) {
      this.productKeys = _.without(this.products.split(","), "");
    }

    this.assignSelectedProducts(this.productKeys);
    this.assignSelectedExternalProducts();

    this.productKeys = _.uniq(this.productKeys);
    this.productKeys = this.productKeys.concat(
      _.pluck(this.hamletAddonProducts, "productKey")
    );
    // Override for no products/addons still after checking all sources - JSW + Confluence default;
    if (
      this.availableProducts.length &&
      !this.selectedProducts.length &&
      !this.selectedAddons.length
    ) {
      this.assignSelectedProducts([
        "jira-software.ondemand",
        "confluence.ondemand",
      ]);
    }
    if (this.showBundle) {
      this.renderBundle(this.activeBundle);
    }
  }

  findBundleWithProductsKeys(matchKey: string) {
    const bundles = this.params.bundleData;
    let result = null;

    Object.keys(bundles).map((bundleKey) => {
      let bundle = bundles[bundleKey];
      if (bundle.bundleProductKeys === matchKey) {
        result = bundle;
      }
    });
    return result;
  }

  getCurrentUrl() {
    const location = Environment.getWindowLocation();
    const internationalSubdomain = Environment.getInternationalSubdomain();
    var newLocation = location.pathname;
    if (
      this.features.enableCombinedBundles &&
      newLocation.includes("/signup-bundles")
    ) {
      newLocation = location.pathname.replace("signup-bundles", "signup");
    }
    let search = location.search;
    if (internationalSubdomain && !this.getLocaleParam()) {
      search = search.length
        ? `${search}&lang=${internationalSubdomain}`
        : `?lang=${internationalSubdomain}`;
    }

    return encodeURIComponent(`${this.baseDomain}${newLocation}${search}`);
  }

  getLoginAccountUrl() {
    const loginUrl = `${this.baseIdDomain}/login?`;
    const currentUrl = this.getCurrentUrl();
    const atlOrigin = `atlOrigin=${this.loginOrigin.encode()}`;
    const continueUrl = `&continue=${currentUrl}`;
    return loginUrl + atlOrigin + continueUrl;
  }

  getSwitchAccountUrl() {
    const logoutUrl = `${this.baseIdDomain}/logout?continue=`;
    const loginUrl = `${this.baseIdDomain}/login?`;
    const currentUrl = `&continue=${this.getCurrentUrl()}`;
    const atlOrigin = `atlOrigin=${this.switchOrigin.encode()}`;

    let continueUrl = currentUrl;
    if (this.socialLogin && this.socialLogin.detectSocialLoginPage()) {
      continueUrl = `&continue=${encodeURIComponent(
        this.socialLogin.getWacTryCloudSignupUrl()
      )}`;
    }

    return logoutUrl + encodeURIComponent(loginUrl + atlOrigin + continueUrl);
  }

  bindElements() {
    this.form = $("form", this.$domRoot);
    this.cofsListContainer = $(
      ".heading--products .products-list",
      this.$domRoot
    );
    this.fields = $("input:input, textarea:input", this.form);
    this.emailField = this.fields.filter("[name=email]");
    this.accountNameField = this.fields.filter("[name=accountName]");
    this.firstNameField = this.fields.filter("[name=firstName]");
    this.lastNameField = this.fields.filter("[name=lastName]");
    this.passwordField = this.fields.filter("[name=aodPass]");
    this.showPasswordField = this.fields.filter("#show-password-checkbox");
    this.submitButton = this.form.find(".imkt--cloud-signup__button--submit");
    this.timeoutWarnings = $(".timeout-warnings", this.$domRoot);
    this.passwordScoreTemplateTarget = this.form.find(
      ".passwordstrength--wrapper"
    );
    this.developerWarning = this.form.find(".developer-container");
    this.captchaContainer = this.form.find(".g-recaptcha-container");
    this.marketingConsentContainer = this.form.find(
      ".marketing-consent--container"
    );
    this.eulaContainer = this.form.find(".eula-container");
    this.annualSubscriptionContent = $("#annual-subscription-chat-link");
    this.linkLoginUser = this.emailField.parent().find(".login-account-url");
    this.linkExistingUser = this.emailField
      .parent()
      .find(".switch-account-url");
    this.dataRegionField = this.form.find("input[type=radio][name=dataRegion]");
  }

  updateSignupDomainLabels() {
    const signupDomainLabels = this.form
      .parent()
      .find(".signup-domain, .site-domain-radix, .signupDomain");

    if (!Environment.isProduction() && signupDomainLabels.length) {
      signupDomainLabels.text(".jira-dev.com");
    }

    // test to see if we are on an opsgenie signup page
    if (this.opsgenieSignupIsActive) {
      const siteInputDomain = this.form.parent().find(".signup-domain");
      var siteHost = this.getOpsgenieSiteHostName();
      siteInputDomain.addClass("opsgenie-signup-domain");
      siteInputDomain.text(siteHost);
      this.accountNameField.addClass("opsgenie-signup-domain");
    }
  }

  updateIdUrls() {
    this.linkLoginUser.attr("href", this.getLoginAccountUrl());
    this.linkExistingUser.attr("href", this.getSwitchAccountUrl());
  }

  bindEvents() {
    var self = this;

    // data center region change handler, update site domain on change
    self.dataRegionField.change(function () {
      // test to see if we are on an opsgenie signup page
      if (self.opsgenieSignupIsActive) {
        const signupDomainLabels = self.form.parent().find(".signup-domain");

        const siteHost = self.getOpsgenieSiteHostName();

        signupDomainLabels.text(siteHost);
        Segment.track({
          category: "wac",
          action: "Opsgenie data region",
          label: this.value,
        });
      }
    });

    onThrottled(this.passwordField,
      "input",
      function (e) {
        self.checkPasswordField(self.passwordField);
        self.renderPasswordStrength(
          self.pw.evaluatePasswordStrength(e.currentTarget.value)
        );
        self.updateFormReady();
      },
      300
    );
    this.showPasswordField.on("click", this.togglePasswordShow.bind(this));

    // Generic Track Link directive
    $("a[track-link-ga]").on("click", function () {
      GoogleAnalytics.track({
        category: "cart-cloud",
        action: "Clicked",
        label: $(this).attr("track-link-ga"),
      });
    });

    // Hamlet validation required on these user inputs
    onThrottled(this.emailField,
      "input",
      this.validateEmailField.bind(this),
      300
    );

    onThrottled(this.accountNameField,
      "input",
      this.validateAccountField.bind(this),
      300
    );

    // Check form ready state on throttled input of first and last name fields
    onThrottled(this.firstNameField,
      "input",
      () => {
        this.checkNameField(this.firstNameField, true);
        this.updateFormReady();
      },
      300
    );
    onThrottled(this.lastNameField,
      "input",
      () => {
        this.checkNameField(this.lastNameField, true);
        this.updateFormReady();
      },
      300
    );

    this.form.on("submit", (e) => {
      e.preventDefault();
      this.submitHandler();
    });

    $(document).on("triggerFormInitTracking", function () {
      Tracking.trackAll(
        "cart-cloud",
        "Viewed Checkout Step",
        "view-signup-page",
        {},
        true
      );
      self.trackAnalyticsProduct(
        0,
        "Added Product",
        "cart-cloud.added-product."
      );
    });

    // Simplified form events
    if (this.features.simpleForm) {
      $(document).on(
        "click",
        ".imkt--cloud-signup__form--simplified .simplified-switch-site",
        function (e) {
          e.preventDefault();

          $(".imkt--cloud-signup__form--simplified .site-chooser-1").hide();
          $(".imkt--cloud-signup__form--simplified .site-chooser-2").show();
        }
      );

      $(document).on(
        "click",
        ".imkt--cloud-signup__form--simplified .simplified-start-new",
        function (e) {
          e.preventDefault();

          // Experiment for 'wcf-459'
          if (
            self.useAlternateLayout &&
            !self.possiblyPremium &&
            !self.migrationSourceUuid &&
            !self.opsgenieSignupIsActive
          ) {
            $(".trial-info-data__trial-length", self.$domRoot).text(
              self.trialBundleData.signupOfferingTrialLengthTextNewSite
            );
          }
          if (
            self.useAlternateLayout &&
            self.possiblyPremium &&
            !self.migrationSourceUuid &&
            self.edition !== self.availableEditions.free
          ) {
            $(".trial-info-data__features-heading", self.$domRoot).text(
              self.trialBundleData.signupOfferingTrialLengthTextNewSite
            );
          }
          // (End) Experiment for 'wcf-459'

          $(".imkt--cloud-signup__form--simplified").hide();
          $(".imkt--cloud-signup__form").show();

          self.trackOptimizedFormEvents("grow.wcf.n2eform.start-new-clicked");
        }
      );

      $(document).on(
        "change",
        ".imkt--cloud-signup__form--simplified input[name='imkt--selected-site']",
        function () {
          var radioButtons = $(
            ".imkt--cloud-signup__form--simplified input[name='imkt--selected-site']"
          );
          var selectedIndex = radioButtons.index(
            radioButtons.filter(":checked")
          );
          self.simplifiedSiteSelected = self.accounts[selectedIndex];
          if ($(this)[0]) {
            self.validateFreeAnnual($(this)[0].value);
          }
          self.trackOptimizedFormEvents("grow.wcf.n2eform.switched");
        }
      );

      $(document).on(
        "click",
        ".imkt--cloud-signup__form--simplified .imkt--cloud-signup__button--submit",
        function (e) {
          e.preventDefault();
          self.disableSubmitButtonSimplified();
          self.submitSimplifiedForm(
            self.simplifiedSiteSelected,
            self.productKeys
          );
        }
      );

      $(document).on(
        "click",
        ".imkt--cloud-signup__form--simplified .switch-account-url-n2e",
        function (e) {
          e.preventDefault();
          tracking.trackEvent(
            "wac-signup-existing-user-switch",
            self.switchOrigin.toAnalyticsAttributes({ hasGeneratedId: true })
          );
          window.location.href = self.getSwitchAccountUrl();
        }
      );
    }

    self.linkExistingUser.on("click", function (e) {
      e.preventDefault();
      tracking.trackEvent(
        "wac-signup-existing-user-switch",
        self.switchOrigin.toAnalyticsAttributes({ hasGeneratedId: true })
      );
      window.location.href = self.getSwitchAccountUrl();
    });

    self.linkLoginUser.on("click", function (e) {
      e.preventDefault();
      tracking.trackEvent(
        "wac-signup-existing-user-signin",
        self.loginOrigin.toAnalyticsAttributes({ hasGeneratedId: true })
      );
      window.location.href = self.getLoginAccountUrl();
    });
  }

  submitHandler() {
    this.disableSubmitButton();
    this.trackOnSubmitEvents();
    this.validateForm();
  }

  formRenderLoggedIn(user) {
    //WCF-1796 we need to remove the social heading when the user is logged in
    $(".heading--social-show").remove();
    this.formRenderReady();

    if (user.myDetails.email) {
      // Update email address field and disable it
      this.emailField.val(user.myDetails.email);
      this.emailField.attr("disabled", "disabled").addClass("disabled");
      this.emailField
        .nextAll(".error-message, .aui-icon, .hamlet-error-message")
        .hide();
      this.emailField.parent().find(".inform-message.logged-in").show();
      this.passwordField.parent().remove();

      if (this.possiblyPremium && this.edition === "premium") {
        $(this.params.fieldIds.sitenameId).find("label .help").replaceWith(`
            <div class="help upgrade">
                <div class="icon-text--help">
                  <span class="icon--help"></span>
                  <span class="text--help">${this.trialBundleData.premiumUpgradeHelpTooltipTrigger}</span>
                </div>
                <div class="tooltip">
                  ${this.trialBundleData.premiumUpgradeHelpTooltipText}
                </div>
            </div>
          `);
      }

      if (!this.accountNameField.val()) {
        this.accountNameField.parent().find(".inform-message.logged-in").show();
      }

      // Hide captcha
      if (this.features.recaptcha) {
        this.features.recaptcha = false;
        this.captchaContainer.remove();
      }

      // Update name fields
      this.firstNameField.val(user.myDetails.firstName);
      this.lastNameField.val(user.myDetails.lastName);

      // No random generated site name for logged in users
      this.features.enableAutogenSiteName = false;
      this.changeSiteNameVisibility(); // force site name to be visible if we've already hidden it

      // NUXAPOLLO-273 No first impression for logged in users.
      this.features.enableFirstImpressions = false;

      // NUXAPOLLO-611 No combined bundles signup for logged in users.
      this.features.enableCombinedBundles = false;

      // NUXAPOLLO-210 No Confluence account setup for logged in users.
      this.features.enableConfluenceAccountSetup = false;

      this.validateEmailField();
      this.updateFormReady();

      this.growthTracker.sendTrack("onload.loggedin");

      if (
        this.features.simpleForm &&
        this.validateN2EProducts() &&
        !this.isDeveloper
      ) {
        // sites as Free edition or regular trial should be eligible to be overlaid
        const extendedTrialOverridableSites =
          this.hamlet.getExtendedTrialAvailableSites();

        // filter users sites by products keys being signed up for
        let filteredSites = this.hamlet.getSites().filter((site) => {
          return (
            !_.some(
              site.products,
              (product) => this.productKeys.indexOf(product) > -1
            ) || extendedTrialOverridableSites.includes(site.cloudId)
          );
        });

        const sortByKey = (array, key) => {
          return array.sort((a, b) => {
            let x = a[key];
            let y = b[key];
            return x < y ? -1 : x > y ? 1 : 0;
          });
        };
        this.accounts = sortByKey(filteredSites, "displayName");
        this.renderOptimizedFlowForm(
          user.myDetails.email,
          user.myDetails.firstName
        );
      }

      // Free: check if first site is on annual billing
      if (
        this.accounts &&
        this.accounts.length > 0 &&
        this.edition == this.availableEditions.free
      ) {
        this.validateFreeAnnualOnLoad(this.accounts[0]);
      }
    }

    $(".icon--cohort-pending").remove();
    this.$domRoot.find(".cohort-pending").removeClass("cohort-pending");
    $(this.$domRoot)
      .find("label .icon--help")
      .mouseover(() => {
        Tracking.trackAll(
          "cart-cloud",
          "Tooltip displayed",
          "?",
          { labelContainer: "help", existingUser: true },
          false
        );
      });
    $("#host_on_server_link a").click((e) => {
      if (e.target.href.match(".*/download"))
        Tracking.trackAll(
          "cart-cloud",
          "Link clicked",
          "host this on your own server?",
          { labelContainer: "cloudSignupBundle", existingUser: true },
          false
        );
    });
  }

  isJsdStandalone(bundle) {
    return (
      (bundle.queryParam &&
        (bundle.queryParam === "jira-service-desk" ||
          bundle.queryParam === "jira-service-management")) ||
      (bundle.bundleProductKeys &&
        (bundle.bundleProductKeys === "jira-servicedesk.ondemand" ||
          bundle.bundleProductKeys === "jira-service-management.ondemand"))
    );
  }

  renderBundle(bundle) {
    var template = _.template(
      $(".template--cloud-signup__form--bundle").html()
    );

    var getFeatureList = (edition) => {
      // Opsgenie only supports one edition
      if (this.opsgenieSignupIsActive) {
        return this.trialBundleData.featureIncludesFreeOpsgenie;
      }

      if (bundle.queryParam === "statuspage") {
        return this.trialBundleData.featureIncludesStatuspage;
      }

      switch (edition) {
        case this.availableEditions.free:
          if (bundle.queryParam) {
            if (this.isJsdStandalone(bundle)) {
              // free bundle, just JSD/JSM
              return this.trialBundleData.featureIncludesFreeJSD;
            } else if (
              bundle.queryParam.indexOf("jira-service-desk") > -1 ||
              bundle.queryParam.indexOf("jira-service-management") > -1 ||
              bundle.bundleProductKeys.indexOf("jira-servicedesk.ondemand") >
              -1 ||
              bundle.bundleProductKeys.indexOf(
                "jira-service-management.ondemand"
              ) > -1
            ) {
              // free bundle that includes JSD
              return this.trialBundleData.featureIncludesFreeBundleJSD;
            }
          }
          return this.trialBundleData.featureIncludesFree;
        case this.availableEditions.premium:
          if (this.isJsdStandalone(bundle)) {
            return this.trialBundleData.featureIncludesPremiumJSD;
          }
          return this.trialBundleData.featureIncludesPremium;
        case this.availableEditions.standard:
          if (this.isJsdStandalone(bundle)) {
            return this.trialBundleData.featureIncludesStandardJSD;
          }
          return this.trialBundleData.featureIncludesStandard;
        default:
          if (this.isJsdStandalone(bundle)) {
            return this.trialBundleData.featureIncludesStandardJSD;
          }
          return this.trialBundleData.featureIncludesStandard;
      }
    };

    $(".column--cloud-signup-bundle").append(
      template({
        useAlternateLayout: this.useAlternateLayout, // Experiment for 'wcf-459'
        trialData: this.trialBundleData, // Experiment for 'wcf-459'
        featureList: getFeatureList(this.edition),
        data: bundle,
        bundleProducts: this.selectedProducts,
        addons: this.hamletAddonProducts,
        edition: this.edition,
        isPremiumEdition: this.edition === "premium",
        possiblyPremium: this.possiblyPremium,
        isExtendedTrial: !!this.migrationSourceUuid,
        isOpsgenie: this.opsgenieSignupIsActive,
        isStatuspage: this.activeBundle.queryParam === "statuspage",
      })
    );

    // We swap out trail length info for Opsgenie
    if (this.opsgenieSignupIsActive) {
      $(".trial-info-data__edition-text", this.$domRoot).text(
        this.trialBundleData.signupOfferingTrialLengthTextNewSiteOpsgenie
      );
    }
  }

  /**
   * Enable simplified signup form if all true:
   * - feature is turned on in CMS
   * - hamlet returned accounts for user
   * - only one selected product (no bundles allowed yet)
   */
  renderOptimizedFlowForm(email, firstName) {
    var productsIncludeStride = this.productKeys.indexOf("hipchat.cloud") > -1;

    if (this.accounts.length && !productsIncludeStride) {
      this.simplifiedSiteSelected = this.accounts[0];

      var simpleTemplate = _.template(
        $(".template--cloud-signup__form--simplified").html()
      );
      this.form.hide();
      this.form.parent().append(
        simpleTemplate({
          useAlternateLayout: this.useAlternateLayout, // Experiment for 'wcf-459'
          trialData: this.trialBundleData, // Experiment for 'wcf-459'
          accounts: this.accounts,
          labels: this.labels,
          email: email,
          firstName: firstName, // Experiment for 'wcf-459'
          switchAccountUrl: this.getSwitchAccountUrl(),
          isPremiumEdition: this.edition === "premium",
          possiblyPremium: this.possiblyPremium,
          isExtendedTrial: !!this.migrationSourceUuid,
        })
      );

      if (
        this.useAlternateLayout &&
        this.possiblyPremium &&
        this.edition !== this.availableEditions.free &&
        !this.migrationSourceUuid &&
        !this.opsgenieSignupIsActive &&
        this.activeBundle.bundleProductKeys !== "statuspage"
      ) {
        $(".trial-info-data__features-heading", this.$domRoot).text(
          this.trialBundleData.signupOfferingTrialLengthTextExistingSite
        );
      }

      this.trackOptimizedFormEvents("grow.wcf.n2eform.loaded");
    } else {
      this.trackOptimizedFormEvents("grow.wcf.n2eform.no-valid-sites");
    }
  }

  // Check the form to see if we should enable the submit button
  updateFormReady() {
    if (this.isFormReady()) {
      this.enableSubmitButton();
    } else {
      var preventSubmitActionText = true;
      this.disableSubmitButton(preventSubmitActionText);
    }
  }

  // Form is ready for submit if fields are valid
  isFormReady() {
    // if form has empty text fields
    var emptyFields = false;

    this.form.find(".required").each((i, item) => {
      if (!$(item).val()) {
        emptyFields = true;
        return false;
      }
    });

    if (emptyFields) {
      return false;
    }

    // if form has errors
    if (this.form.find(".has-error").length) {
      return false;
    }

    return true;
  }

  trackOptimizedFormEvents(eventName) {
    var anonymous_id = storage.getCookie("ajs_anonymous_id") || "-";
    var opt_id = "unknown";
    var cohort = this.productKeys.length > 1 ? "control" : "variation-home";

    var siteHost = Environment.isProduction()
      ? ".atlassian.net"
      : ".jira-dev.com";
    if (this.opsgenieSignupIsActive) {
      siteHost = this.getOpsgenieSiteHostName();
    }

    var selectedSiteFull = this.simplifiedSiteSelected.displayName + siteHost;

    var postBody = {
      name: eventName,
      properties: {
        variationValue: cohort,
        formId: "wcf",
        opt_id: opt_id,
        pathname: window.location.pathname || "",
        products: this.productKeys.join(","),
      },
      cloud_id: this.simplifiedSiteSelected.cloudId || "",
      server: selectedSiteFull,
      serverTime: Date.now(),
      product: "wac",
      user: anonymous_id,
    };

    GASv2.track(postBody);
  }

  // this takes the products in productkeys and check availableProducts for their N2E properties
  // if ALL the products have N2E enabled, then we pass the check
  validateN2EProducts() {
    var self = this;
    var enableOptimizedFlow = true;
    this.productKeys.forEach(function (product) {
      var matchingProduct = _.find(self.availableProducts, {
        product_key: product,
      });
      if (matchingProduct) {
        enableOptimizedFlow =
          enableOptimizedFlow && matchingProduct.n2e_enabled;
      }
    });
    return enableOptimizedFlow;
  }

  validateEmailField() {
    var self = this;
    var email = this.emailField.val();

    // reset error messages
    this.emailField
      .nextAll(".error-message, .hamlet-error-message, .aui-icon")
      .hide();
    this.emailField.removeClass(this.ERROR_CLASS);

    // Experiment for 'wcf-459'
    if (this.useAlternateLayout) {
      this.emailField.removeClass("is-success");
    }

    // Fail fast if email was filled in from logged in session
    // Note: if user is logged in, email should be already assigned and disabled
    if (email && this.hamlet.isLoggedIn()) {
      this.updateFormReady();
      return;
    }

    // test for valid email syntax
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(email)) {
      this.emailField.nextAll(".error-message").show();
      this.emailField.addClass(this.ERROR_CLASS);
      this.growthTracker.sendTrack("email.errors");
      this.updateFormReady();
      return false;
    }

    // show spinner icon
    this.emailField
      .nextAll(".aui-iconfont-build")
      .css("display", "inline-block");

    // Check hamlet for existing email
    var successApi = function (res) {
      self.emailField.nextAll(".aui-iconfont-build").hide();

      // Success response means that email exists, which we dont want here...
      var success = res && !res.success;
      if (!success && res.message) {
        self.emailField.nextAll(".hamlet-error-message").show();
        self.emailField.addClass(self.ERROR_CLASS);
        self.growthTracker.sendTrack("email.errors");
      } else {
        self.emailField
          .nextAll(".email-validation-success")
          .css("display", "inline-block");

        // Experiment for 'wcf-459'
        if (self.useAlternateLayout) {
          self.emailField.addClass("is-success");
        }
      }
      self.updateFormReady();
    };
    var failApi = function () {
      self.emailField.nextAll(".hamlet-error-message").show();
      self.emailField.addClass(self.ERROR_CLASS);
      self.emailField.nextAll(".aui-iconfont-build").hide();
      self.growthTracker.sendTrack("email.errors");
      self.updateFormReady();
    };

    this.hamlet
      .validateEmail(email)
      .then((result) => successApi(result))
      .catch((e) => failApi(e));
  }

  validateAccountField() {
    var self = this;
    var value = this.accountNameField.val();

    this.accountNameField
      .nextAll(".error-message, .aui-icon, .inform-message")
      .hide();
    this.accountNameField.removeClass(this.ERROR_CLASS);

    // Experiment for 'wcf-459'
    if (this.useAlternateLayout) {
      this.accountNameField.removeClass("is-success");
    }

    if (!value) {
      this.updateFormReady();
      return false;
    }

    if (
      !this.cofs.checkCloudNameMin(value) ||
      !this.cofs.isValidCloudNamePattern(value)
    ) {
      this.accountNameField.nextAll(".error-message.domain-length-min").show();
      this.accountNameField.addClass(this.ERROR_CLASS);
      this.updateFormReady();
      return false;
    }
    if (!this.cofs.checkCloudNameMax(value)) {
      this.accountNameField.nextAll(".error-message.domain-length-max").show();
      this.accountNameField.addClass(this.ERROR_CLASS);
      this.updateFormReady();
      return false;
    }

    this.accountNameField
      .nextAll(".aui-iconfont-build")
      .css("display", "inline-block");

    var successApi = function (res) {
      var success = res && res.available;
      self.accountNameField.nextAll(".aui-iconfont-build").hide();

      // Show user the domain is in use
      if (success) {
        // domain is available
        self.accountNameField
          .nextAll(".validation-success")
          .css("display", "inline-block");

        // Experiment for 'wcf-459'
        if (self.useAlternateLayout) {
          self.accountNameField.addClass("is-success");
        }
      } else {
        self.accountNameField
          .nextAll(".error-message.domain-unavailable")
          .show();
        self.accountNameField.addClass(self.ERROR_CLASS);

        // Experiment for 'wcf-459'
        if (this.useAlternateLayout) {
          this.accountNameField.removeClass("is-success");
        }

        // If user is logged in ask them if they want to add products their domain
        if (self.hamlet.isLoggedIn()) {
          self.accountNameField
            .nextAll(".inform-message.domain-unavailable.logged-in")
            .show();
        }

        self.growthTracker.sendTrack("accountName.errors");
      }
      self.updateFormReady();
    };

    var failApi = function () {
      self.accountNameField.nextAll(".aui-iconfont-build").hide();
      self.accountNameField.nextAll(".error-message.domain-unavailable").show();
      self.accountNameField.addClass(self.ERROR_CLASS);
      self.growthTracker.sendTrack("accountName.errors");
      self.updateFormReady();
    };

    this.cofs
      .validateCNAS(value)
      .then((result) => successApi(result))
      .catch(() => failApi());
  }

  validateForm() {
    var self = this;

    if (!this.validateClientSide()) {
      return false;
    }

    // Track form submit attempt (pre-server validation)
    var productTrackingValue = {
      value: `cart-cloud.submitted.${this.selectedProducts[0].product_key}`,
    };
    var bxpProductTrackingValue = { value: "cart-cloud.submitted.bxp" };

    Tracking.trackAll(
      "cart-cloud",
      "Submitted",
      "cloud",
      productTrackingValue,
      false
    );
    Tracking.trackAll(
      "cart-cloud",
      "Submitted.user.status",
      "form event",
      { existingUser: this.hamlet.isLoggedIn() },
      false
    );
    Tracking.trackAll(
      "cart-cloud",
      "Submitted BXP Form",
      "cloud",
      bxpProductTrackingValue,
      false
    );

    // Disable submit while server side validating
    if (!this.features.performanceBoost) {
      this.disableSubmitButton();
    }

    // Popup warning for external products signup
    if (self.selectedAddons.length) {
      self.popupReminderExternalProducts();
    }

    // Validate server side
    this.formData = _.object(
      this.form.serializeArray().map(function (v) {
        return [v.name, v.value];
      })
    );
    this.formData["productKeys"] = this.productKeys;
    if (typeof this.formData["email"] === "undefined") {
      this.formData["email"] = this.emailField.val();
    }

    if (this.features.enableAutogenSiteName) {
      this.formData["accountName"] = `NUXSIGNUP-default-${Date.now()}`;
    }

    this.submitCloud();
  }

  validateClientSide() {
    // reset main error message
    this.form.find(".validation-error-message, .error-message").hide();
    this.hideErrorCaptcha();

    this.checkField(this.firstNameField, true);
    this.checkField(this.lastNameField, true);
    this.checkAccountField(this.accountNameField);
    this.checkField(this.emailField);
    this.checkPasswordField(this.passwordField);

    // Find visible field errors
    var errors = $(".error-message, .hamlet-error-message").filter(":visible");
    if (errors.length) {
      this.form.find(".validation-error-message").show();

      // Send each client-side validation error to analytics
      $(errors).each(function () {
        var errorMsg = $(this)
          .text()
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/,/g, "");
        if (errorMsg) {
          Tracking.trackAll(
            "cart-cloud",
            "Submitted with validation Error",
            "cloud",
            { value: errorMsg },
            false
          );
        }
      });

      return false;
    }

    return true;
  }

  submitSimplifiedForm(site, productKeys) {
    const startUrl = Environment.getStartUrl();
    let startSearch = `?startTrialProduct=${productKeys[0]}&startTrialCloudId=${site.cloudId
      }&startTrialInstance=${site.url.replace("https://", "")}`;

    if (this.edition) {
      startSearch += `&edition=${this.edition}`;
    }
    if (this.migrationSourceUuid) {
      startSearch += `&migrationSourceUuid=${this.migrationSourceUuid}`;
    }

    const adminPath = "/admin/billing/applications";
    const adminSearch = "";

    let url = `${site.url}${adminPath}${adminSearch}`;
    let cohort = "control";

    if (productKeys.length === 1) {
      url = `${startUrl}${startSearch}`;
      cohort = "variation-start";
    }

    const anonymous_id =
      storage.getCookie("ajs_anonymous_id") || "-";
    const opt_id = "unknown";

    const eventName = "grow.wcf.n2eform.submit";

    const postBody = {
      name: eventName,
      properties: {
        variationValue: cohort,
        formId: "wcf",
        opt_id: opt_id,
        pathname: window.location.pathname || "",
        products: productKeys.join(","),
      },
      cloud_id: site.cloudId || "",
      server: url,
      serverTime: Date.now(),
      product: "wac",
      user: anonymous_id,
    };

    var redirectCallback = function () {
      window.location.href = url;
    };

    GASv2.track(postBody).then(redirectCallback).catch(redirectCallback);
  }

  isCloudIdAnnualAsync(options, errCallback) {
    const { cloudId, cloudName, userId } = options;
    $(".site-switcher label").removeClass("error-active");

    this.cofs
      .isCloudIdAnnual(cloudId, userId)
      .then((result) => {
        if (result === true) {
          $(`.site-switcher label[for='${cloudName}']`).addClass(
            "error-active"
          );
          this.disableSubmitButtonSimplified();
          if (errCallback) errCallback();
        } else {
          this.enableSubmitButtonSimplified();
        }
      })
      .catch((e) => console.error(e));
  }

  validateFreeAnnualOnLoad(cloudObj) {
    const opts = {
      cloudId: cloudObj.cloudId,
      cloudName: cloudObj.displayName,
      userId: this.user?.myDetails?.aaid,
    };

    if (!opts.cloudId || !opts.cloudName || !opts.userId) {
      return;
    }

    this.isCloudIdAnnualAsync(opts, function () {
      $(".imkt--cloud-signup__form--simplified .site-chooser-1").hide();
      $(".imkt--cloud-signup__form--simplified .site-chooser-2").show();
    });
  }

  // validate that Free is not annual
  validateFreeAnnual(inputId) {
    var userId = this.user?.myDetails?.aaid;
    var cloudId = this.simplifiedSiteSelected.cloudId;

    if (
      !userId ||
      !cloudId ||
      !inputId ||
      this.edition !== this.availableEditions.free
    )
      return;

    this.isCloudIdAnnualAsync({
      cloudId,
      cloudName: inputId,
      userId,
    });
  }

  submitCloud() {
    this.cofsCreateCloud();
  }

  cofsCreateCloud() {
    var self = this;
    var data = this.formData;
    const submitThroughBxp = this.params.submitBxpExpress || false;

    // Data Center Region
    // remove if we are not dealing with opsgenie product
    if (!this.opsgenieSignupIsActive) {
      data.dataRegion = null;
    } else {
      data.initialProductURL = this.getOpsgenieInitialProductURL();
    }

    // Insert coupon if its valid/exists
    if (this.coupon) {
      data.coupon = this.coupon;
    }

    // Insert template id if it exists
    if (this.templateId) {
      data.templateId = this.templateId;
    }

    // Insert Users Captcha token
    if (!this.hamlet.isLoggedIn()) {
      data.responseToken = grecaptcha.getResponse();
      this.userSubmittedWithCaptcha = true;
    }

    // Insert consent payload if gdpr enabled
    if (this.params.useGDPR) {
      if (this.useSocialLogin) {
        // In social login flow, Identity will capture and send the marketing consent
        // info to the ConsentHub once the user confirms the ATL account creation.
        // Setting consent data to undefined in the payload to COFS create cloud API
        // will allow COFS to skip the CONSENTHUB_SEND_CONSENT step and avoid overriding
        // the marketing consent info captured by Identity.
        delete data.consent;
      } else {
        var consent = this.buildConsentPayload();

        if (consent) {
          data.consent = consent;
        }
      }
    }

    // Insert edition property if it exists
    if (this.edition) {
      data.edition = this.edition;
    }

    // Insert migrationSourceUuid property if it exists
    if (this.migrationSourceUuid) {
      data.migrationSourceUuid = this.migrationSourceUuid;
    }

    this.experiments.insertExperimentProperties(data);
    var cofsData = this.cofs.mapCofsData(data, {
      submitThroughBxp,
      enableAutogenSiteName:
        this.features.enableAutogenSiteName || this.useSocialLogin,
      useSocialLogin: this.useSocialLogin,
      enableConfluenceAccountSetup: this.features.enableConfluenceAccountSetup,
      allowResendVerificationEmail: this.features.allowResendVerificationEmail,
    });

    var fail = function (error) {
      if (self.useSocialLogin) {
        self.socialLogin.showSocialLoginError("create-cloud-error");
        return;
      }

      if (submitThroughBxp && error.response && error.response.data) {
        if (error.response.data.cloudName) {
          self.accountNameField
            .nextAll(".error-message.domain-length-min")
            .show();
          self.accountNameField.addClass(self.ERROR_CLASS);
        }
        if (error.response.data.firstName) {
          self.firstNameField.nextAll(".error-message").show();
          self.firstNameField.addClass(self.ERROR_CLASS);
        }
        if (error.response.data.lastName) {
          self.lastNameField.nextAll(".error-message").show();
          self.lastNameField.addClass(self.ERROR_CLASS);
        }
        if (error.response.data.email) {
          self.emailField.nextAll(".error-message").show();
          self.emailField.addClass(self.ERROR_CLASS);
        }
        if (error.response.data.adminPassword) {
          self.passwordField.nextAll(".error-message").show();
          self.passwordField.addClass(self.ERROR_CLASS);
        }
      }

      self.timeoutWarnings.find(".error-message.timeout-error").show();
      Tracking.trackAll(
        "cart-cloud",
        "Submitted with Error",
        "cloud",
        {},
        false
      );

      // Additional tracking for field error keys when server error
      self.trackServerValidationFieldErrors(error);

      return;
    };

    this.cofs
      .createCloud(cofsData, submitThroughBxp, this.hamlet.isLoggedIn())
      .then((resData) => {
        const cloudName = resData.cloudName
          ? resData.cloudName
          : cofsData.cloudName;
        const clientName = this.formData["accountName"];
        const cloudId = resData.cloudId || null;

        try {
          if (this.useSocialLogin) {
            // Save social login cloud data to session storage to prevent additional cloud
            // creation if the user navigates back to the signup social login page via
            // the BACK button
            this.socialLogin.sessionStorageSaveCloudData(this.user.myDetails, {
              cloudId,
              cloudName,
              requestId: this.cofs.getRequestId(resData.progressUri),
              productKeys: this.productKeys,
            });
          }
          // eslint-disable-next-line no-empty
        } catch (e) { }

        if (this.useSocialLogin && this.features.enableConfluenceAccountSetup) {
          this.updateStatusResults(resData.progressUri, cloudName, clientName);
        } else if (this.useSocialLogin) {
          this.goToRenameSite(resData);
        } else {
          this.updateStatusResults(resData.progressUri, cloudName, clientName);
        }
      })
      .catch((e) => fail(e));
  }

  buildConsentPayload() {
    var consentEulaText = this.form
      .find(".eula-container")
      .html()
      .replace(/"/g, '\\"')
      .trim();
    var generalMarketingOptInLabel = this.form
      .find(".marketing-consent--container")
      .text()
      .replace(/"/g, '\\"')
      .trim();
    var marketingConsentGranted = this.form
      .find("#marketing_consent")
      .is(":checked");

    if (!this.consentConfig.localeRequiresMarketingCommunicationOptIn) {
      generalMarketingOptInLabel = "general consent captured";
      marketingConsentGranted = true;
    }

    if (
      !this.consentConfig.locale ||
      !consentEulaText ||
      !generalMarketingOptInLabel
    ) {
      Tracking.trackAll(
        "cart-cloud",
        "ConsentHub payload error",
        "cloud",
        {},
        false
      );
      return false;
    }

    return {
      site: "atlassian",
      locale: this.consentConfig.locale,
      formUrl: encodeURIComponent(window.location.href),
      consents: [
        {
          key: "termsOfService",
          displayedText: consentEulaText,
          granted: true,
        },
        {
          key: "privacyPolicy",
          displayedText: consentEulaText,
          granted: true,
        },
        {
          key: "generalMarketingOptIn",
          displayedText: generalMarketingOptInLabel,
          granted: marketingConsentGranted,
        },
      ],
    };
  }

  cancelSignupTimeoutEvents() {
    clearTimeout(this.timerWarning);
    clearTimeout(this.timerError);
    clearInterval(this.tryAgain);

    this.timerWarning = 0;
    this.timerError = 0;
    this.tryAgain = 0;
  }

  /**
   * Track Analytics for complete signup
   */
  sendFinishAnalytics(cloudId, cloudName, requestId, callback) {
    this.growthTracker.sendTrack("form_submit_signup_success");
    Tracking.trackAll(
      "cart-cloud",
      "form_submit_signup_success.user.status",
      "form event",
      { existingUser: this.hamlet.isLoggedIn() },
      false
    );
    this.growthTracker.sendTrackSubmitSuccess("bxp_form_success");

    var anonymous_id = storage.getCookie("ajs_anonymous_id") || "-"; // Anonymous user, otherwise send the userID
    var opt_id = "unknown";
    var cross_domain_id = storage.getCookie("seg_xid") || "";

    if (typeof analytics !== "undefined") {
      var properties = {
        cloud_id: cloudId,
        request_id: requestId,
        product_list: this.productKeys.join(","),
        cloud_name: cloudName,
        source: window.location.pathname,
        cross_domain_id: cross_domain_id,
        anonymous_id: anonymous_id,
        opt_id: opt_id,
        edition: this.edition || "",
      };
      tracking.trackEvent(
        "create_cloud_embedded_form_wac",
        properties
      );
    }

    Tracking.trackAll(
      "cart-cloud",
      "Completed Checkout Step",
      "complete-signup-page",
      {
        value: cloudId,
        requestId: requestId,
        isRecaptchaV2: this.features.recaptcha,
        isInvisibleRecaptcha: this.features.invisibleRecaptcha,
        existingUser: this.hamlet.isLoggedIn(),
      },
      true
    );
    this.trackAnalyticsProduct(
      0,
      "Confirmed Evaluation",
      "cart-cloud.confirmed-evaluation."
    );
    Tracking.trackAll(
      "cart-cloud",
      "Confirmed Evaluation.user.status",
      "form event",
      { existingUser: this.hamlet.isLoggedIn() },
      false
    );

    setTimeout(function () {
      callback();
    }, 800);
  }

  /**
   * Gets setup status using progressURI from cloud api request
   */
  updateStatusResults(progressUri, cloudName, clientName) {
    var self = this;
    if (!progressUri) {
      self.timeoutWarnings.find(".error-message.timeout-error").show();

      return;
    }

    if (typeof self.tryAgain === "undefined") {
      self.tryAgain = setInterval(function () {
        self.updateStatusResults(progressUri, cloudName, clientName);
      }, 1000);
    }

    if (typeof self.timerWarning === "undefined") {
      // Set timeouts to log slow account creations on first call
      self.timerWarning = setTimeout(function () {
        self.timeoutWarnings.find(".error-message.timeout-warning").show();
        Tracking.trackAll(
          "cart-cloud",
          "Waited",
          "Sign-up page submitted >15s",
          {},
          false
        );
      }, 15 * 1000);

      self.timerError = setTimeout(function () {
        self.timeoutWarnings.find(".error-message.timeout-error").show();
        Tracking.trackAll(
          "cart-cloud",
          "Waited",
          "Sign-up page submitted >60s",
          {},
          false
        );
        clearInterval(self.tryAgain);
      }, 60 * 1000);
    }

    $.ajax({
      url: progressUri,
      type: "GET",
      success: $.proxy(function (res) {
        var status =
          res.bestStatuses["HAMS_CREATE_CLOUD"] !== "SKIPPED"
            ? res.bestStatuses["HAMS_CREATE_CLOUD"]
            : res.bestStatuses["BAG_CREATE_CLOUD"];

        switch (status) {
          case "COMPLETE_SUCCESS":
          case "COMPLETE_MANUAL_SUCCESS":
            self.cancelSignupTimeoutEvents();

            var cloudId = res.cloudId || null;
            var callback = function () {
              if (
                self.useSocialLogin &&
                self.features.enableConfluenceAccountSetup
              ) {
                self.goToAccountSetup(res.cloudId, res.requestId, cloudName);
              } else if (
                self.hamlet.isLoggedIn() ||
                self.experiments.bypassEmailCheck
              ) {
                self.goToConfirmation(res, progressUri, cloudName, clientName);
              } else {
                self.goToCheckEmail(res.cloudId, res.requestId, cloudName);
              }
            };

            self.sendFinishAnalytics(
              cloudId,
              cloudName,
              res.requestId,
              callback
            );
            return;

          case "COMPLETE_ERROR":
            self.cancelSignupTimeoutEvents();
            self.timeoutWarnings.find(".error-message.timeout-error").show();
            Tracking.trackAll(
              "cart-cloud",
              "Progress Error",
              "cloud",
              {},
              false
            );

            return;

          default:
            // Re-Try via tryAgain interval
            return;
        }
      }, this),
      error: $.proxy(function () {
        self.timeoutWarnings.find(".error-message.timeout-error").show();
        Tracking.trackAll(
          "cart-cloud",
          "Progress Error",
          "cloud",
          {},
          false
        );
      }, this),
    });
  }

  trackServerValidationFieldErrors(err) {
    try {
      if (_.has(err, "fieldErrors")) {
        Tracking.trackAll(
          "cart-cloud",
          "Submitted with Error Field Errors",
          "cloud",
          { value: JSON.stringify(err.fieldErrors) },
          false
        );
      } else if (_.has(err, "error")) {
        Tracking.trackAll(
          "cart-cloud",
          "Submitted with Error Server Error",
          "cloud",
          { value: JSON.stringify(err.error) },
          false
        );
      }
    } catch (e) {
      Tracking.trackAll(
        "cart-cloud",
        "Submitted with Error Response",
        "cloud",
        {},
        false
      );
    }
  }

  /**
   * On successful account creation, redirect to Confluence account setup
   */
  goToAccountSetup(cloudId, requestId, cloudName) {
    this.growthTracker.sendTrack("navigatedToAccountSetup");

    if (!cloudId) {
      this.timeoutWarnings.find(".error-message.timeout-error").show();
      return false;
    }

    const ondemandurl = cloudName;
    const products = this.productKeys.join(",");
    var queryParams = {
      cloudId,
      ondemandurl,
      products,
      requestId,
    };

    var urlParams = $.param(queryParams);
    var nextUrl =
      this.baseDomain + this.URL_ACCOUNT_SETUP_PATH + "/?" + urlParams;

    window.location = nextUrl;
    return;
  }

  /**
   * On successful account creation, redirect to cloud success page
   */
  goToConfirmation(data, progressUri, cloudName) {
    this.growthTracker.sendTrack("navigatedToConfirmation");

    if (!data) {
      this.timeoutWarnings.find(".error-message.timeout-error").show();
      return false;
    }

    let ondemandUrl = this.formData.accountName;
    if (cloudName) {
      ondemandUrl = cloudName;
    }

    var queryParams = {
      ondemandurl: ondemandUrl,
      products: this.productKeys.join(","),
      cloudId: data.cloudId,
      requestId: this.cofs.getRequestId(progressUri),
    };

    if (this.opsgenieSignupIsActive) {
      queryParams.dataRegion = this.dataRegionField.filter(":checked").val();
    }

    var urlParams = $.param(queryParams);
    var nextUrl =
      this.baseDomain + this.URL_CONFIRMATION_PATH + "/?" + urlParams;

    window.location = nextUrl;
    return;
  }

  checkPerms(cloudId) {
    return retry(
      async (bail) => {
        // if anything throws, we retry
        let postBody = {
          dontRequirePrincipalInSite: "true",
          permissionId: "manage",
          resourceId: `ari:cloud:platform::site/${cloudId}`,
        };

        let options = {
          headers: {
            "content-type": "application/json",
          },
          method: "POST",
          body: JSON.stringify(postBody),
        };
        let perms = await fetch(
          `${Environment.getAPIPrivateURL()}/permissions/permitted`,
          options
        );

        if (
          403 === perms.status ||
          401 === perms.status ||
          500 === perms.status
        ) {
          bail(new Error("Unauthorized or Server error"));
          return;
        }
        //retry if Perms returned http != 200
        if (200 !== perms.status) {
          throw new Error(
            "bxp.cloud-signup.rename.site.permissions.check.failed"
          );
        }

        const data = await perms.json();
        //retry if Perms returned http 200 with permitted=false
        if (true !== data.permitted) {
          throw new Error(
            "bxp.cloud-signup.rename.site.permissions.check.false"
          );
        }
        return data;
      },
      {
        retries: 4,
        minTimeout: 1000,
        maxTimeout: 1000,
      }
    );
  }

  /**
   * On successful account creation, but user not logged in
   */
  goToCheckEmail(cloudId, requestId, autoGeneratedCloudName) {
    this.growthTracker.sendTrack("navigatedToCheckEmail");

    var queryParams = {
      accountName: this.formData.accountName,
      products: this.productKeys.join(","),
    };

    if (this.features.enableAutogenSiteName) {
      if (this.features.allowResendVerificationEmail) {
        queryParams.accountName = autoGeneratedCloudName;
      } else {
        delete queryParams.accountName;
      }
    }

    /**
     * @todo: $scope.email = MemoryStorage.checkEmailAddress;
     * ... used by ondemand app in the checkemail controller, but not sure what MemoryStorage is setting.
     */
    this.setResendEmailParams(cloudId, requestId, autoGeneratedCloudName);
    var urlParams = $.param(queryParams);
    var nextUrl = this.baseDomain + this.URL_CHECKEMAIL_PATH + "/?" + urlParams;

    window.location = nextUrl;
    return;
  }

  /**
   *  Server Validation failed, prompt user to check fields and reset submit button
   */
  showInvalidForm(adminErrors) {
    var self = this;

    self.submitButton.find(".submit--initial-text").show();
    self.submitButton.find(".submit--processing-text").hide();
    self.submitButton.removeAttr("disabled");
    self.form.find(".validation-error-message").show();

    self.form.find(".admin-error-message").empty();
    $.each(adminErrors, function (k, v) {
      self.form
        .find(".admin-error-message")
        .append("<br/>" + v)
        .show();

      // Track a server side validation error (FOR EACH FIELD)
      Tracking.trackAll(
        "cart-cloud",
        "Submitted with validation Error",
        "cloud",
        {},
        false
      );
    });
  }

  /**
   * Check client side for missing input
   */
  checkField($field, clearErrors) {
    if (!$field.val().length) {
      $field.nextAll(".error-message").show();
      $field.addClass(this.ERROR_CLASS);
    } else if (clearErrors) {
      $field.nextAll(".error-message").hide();
      $field.removeClass(this.ERROR_CLASS);
    }
  }

  /**
   * First and last name must pass a validation pattern in COFS
   */
  checkNameField($field, clearErrors) {
    const invalidNamePattern =
      /((http(s)?|ftp|callto|mailto|skype|magnet):)|www\.|:\/\/|@|\$/i;
    var fieldName = $field.attr("name");
    if (invalidNamePattern.test($field.val())) {
      $field.nextAll(".error-message").show();
      $field.addClass(this.ERROR_CLASS);
      this.growthTracker.sendTrack("fullName.errors");

      // NUXAPOLLO-452 add tracking for firstname and lastname error
      Tracking.trackAll(
        "cart-cloud",
        "Typed " + fieldName + " Error",
        "cloud",
        {},
        false
      );
    } else if (clearErrors) {
      $field.nextAll(".error-message").hide();
      $field.removeClass(this.ERROR_CLASS);

      // NUXAPOLLO-452 add tracking for firstname and lastname success
      Tracking.trackAll(
        "cart-cloud",
        "Typed " + fieldName + " Success",
        "cloud",
        {},
        false
      );
    }
  }

  checkPasswordField($field) {
    if ($field.val().length < 8) {
      $field.nextAll(".error-message").show();
      $field.addClass(this.ERROR_CLASS);

      // NUXAPOLLO-452 add tracking for password error
      Tracking.trackAll(
        "cart-cloud",
        "Typed Password Error",
        "cloud",
        {},
        false
      );
    } else {
      $field.nextAll(".error-message").hide();
      $field.removeClass(this.ERROR_CLASS);

      // NUXAPOLLO-452 add tracking for password success
      Tracking.trackAll(
        "cart-cloud",
        "Typed Password Success",
        "cloud",
        {},
        false
      );
    }
  }

  /**
   * check for empty account/domain field
   */
  checkAccountField($field) {
    if (this.features.enableAutogenSiteName) {
      return;
    }

    if (!$field.val().length) {
      $field.nextAll(".domain-length-min").show();
      $field.addClass(this.ERROR_CLASS);
    }
  }

  /**
   * Render ReCaptcha with callback properties
   */
  renderCaptcha() {
    if (!this.features.recaptcha) {
      return;
    }

    var captchaOptions = {
      sitekey: "6LePw0oUAAAAAFjgRJCH0IGJeoXmYxWbsKpTHRMx",
      callback: this.updateCaptcha.bind(this),
      "expired-callback": this.resetCaptcha.bind(this),
    };
    var captchaRenderElement = document.getElementById("g-recaptcha-render");
    $(captchaRenderElement).parent().addClass("rendered");

    grecaptcha.render(captchaRenderElement, captchaOptions);
  }

  renderInvCaptcha() {
    if (!this.features.invisibleRecaptcha) {
      return;
    }

    var captchaRenderElement = document.getElementById(
      "inv-recaptcha-signup_submit"
    );

    grecaptcha.render(captchaRenderElement);
    this.disableSubmitButton(true);
  }

  /**
   * Captcha callback on user interaction success
   */
  updateCaptcha() {
    captchaFilled = true;
    this.hideErrorCaptcha();
    this.updateFormReady();
  }

  /**
   * Reset ReCaptcha when a user idles too long
   */
  resetCaptcha() {
    grecaptcha.reset();
    this.updateFormReady();
    this.captchaContainer.removeClass(this.ERROR_CLASS);
    Tracking.trackAll(
      "cart-cloud",
      "ReCaptcha Reset",
      "cloud",
      {},
      false
    );
  }

  showErrorCaptcha() {
    this.captchaContainer.addClass(this.ERROR_CLASS);
    this.captchaContainer.find(".error-message").show();
    Tracking.trackAll(
      "cart-cloud",
      "ReCaptcha Error",
      "cloud",
      {},
      false
    );
  }

  hideErrorCaptcha() {
    this.captchaContainer.removeClass(this.ERROR_CLASS);
    this.captchaContainer.find(".error-message").hide();
  }

  /**
   * Sanitize client side product keys to match server side available products
   */
  assignSelectedProducts(items) {
    const self = this;

    _.each(items, function (productKey) {
      const product = _.find(self.availableProducts, {
        product_key: productKey,
      });
      if (product) {
        // test for opsgenie product
        if (productKey === "opsgenie") {
          self.opsgenieSignupIsActive = true;
          const dataRegionFieldContainer = $(self.params.fieldIds.dataRegionId);
          dataRegionFieldContainer.show();

          // NUXSIGNUP-7 disable experiment for opsgenie signup
          self.features.enableAutogenSiteName = false;
          self.changeSiteNameVisibility(); // force site name to be visible if we've already hidden it

          // NUXAPOLLO-210 No Confluence account setup for logged in users.
          self.features.enableConfluenceAccountSetup = false;
        }

        if (productKey === "opsgenie" || productKey.includes("bitbucket")) {
          // NUXAPOLLO-54 disable experiment for opsgenie and bitbucket signup
          self.features.enableContinueWithGoogle = false;
          self.features.enableContinueWithMicrosoft = false;
          self.features.enableFirstImpressions = false;
          // NUXAPOLLO-611 disable combined bundles signup
          self.features.enableCombinedBundles = false;
        }

        if (product.cofs_enabled) {
          if (
            productKey === "bitbucket.ondemand" &&
            !self.features.allowBitbucket
          ) {
            self.selectedAddons.push(product);
          } else {
            self.selectedProducts.push(product);
            self.productKeys.push(product.product_key);
          }
        } else {
          self.selectedAddons.push(product);
        }

        const urlEdition = self.checkUrlEditionKey();
        self.edition = urlEdition
          ? self.sanitizeEditionForProduct(urlEdition, product)
          : null;

        self.migrationSourceUuid = self.checkUrlMigrationSourceUuidKey();
      }
    });

    if (!items || !items.length || items[0] != CONFLUENCE_PRODUCT_KEY) {
      // Confluence has to be the base target product
      self.features.enableConfluenceAccountSetup = false;
    }

    // Remove the edition and migrationSourceUuid property if more than one product in signup
    if (self.selectedProducts.length > 1) {
      // do not remove the (set to standard) edition if this signup is for free
      if (self.edition !== this.availableEditions.free) {
        self.edition = null;
      }
      self.migrationSourceUuid = null;
    }

    // We are going to override the edition with the signupEdition from Magnolia Dialog
    if (
      Object.values(this.availableEditions).includes(this.params.signupEdition)
    ) {
      this.edition = this.params.signupEdition;
    }
  }

  sanitizeEditionForProduct(edition, product) {
    if (edition === this.availableEditions.premium && product.premium_enabled) {
      return this.availableEditions.premium;
    } else if (
      edition === this.availableEditions.free &&
      product.free_enabled
    ) {
      if (
        window.localStorage.getItem("bxp_science_sci279") ||
        window.localStorage.getItem("bxp_science_sci280") ||
        !!(
          imkt.constants &&
          imkt.constants.isFreeEnabled
        )
      ) {
        return this.availableEditions.free;
      }
      return this.availableEditions.standard;
    } else if (edition === this.availableEditions.standard) {
      return this.availableEditions.standard;
    } else {
      return null;
    }
  }

  /**
   * Sanitize client side product keys to match server side available external products
   */
  assignSelectedExternalProducts() {
    const urlParams = url.getUrlParams() || {};
    const productParam = urlParams["product"] || false;

    if (productParam) {
      const items = productParam.split(",");

      _.each(items, (productKey) => {
        const product = _.find(this.availableProducts, {
          product_key: productKey,
        });

        if (
          (product && !product.cofs_enabled) ||
          (productKey === "bitbucket.ondemand" && !this.features.allowBitbucket)
        ) {
          this.selectedAddons.push(product);
        }
      });
    }
  }

  /**
   * Check for edition key in url
   */
  checkUrlEditionKey() {
    const params = url.getUrlParams() || {};
    return params["edition"] || null;
  }

  /**
   * Check for migrationSourceUuid key in url
   */
  checkUrlMigrationSourceUuidKey() {
    const params = url.getUrlParams() || {};
    return params["migrationSourceUuid"] || null;
  }

  /**
   * Check for product keys in url
   */
  checkUrlProductKeys() {
    var urlParams = url.getUrlParams() || {};
    var productParam = urlParams["product"] || false;

    if (productParam) {
      // Reset any selections for url override
      this.selectedProducts = [];
      this.selectedAddons = [];
      this.productKeys = [];

      this.products = productParam;
      this.assignSelectedProducts(this.products.split(","));
    }
  }

  /**
   * Check for bundle key in url
   */
  checkUrlBundleKey() {
    var urlParams = url.getUrlParams() || {};
    var param = urlParams["bundle"] || false;
    var bundleData = this.bundleData[param];
    if (bundleData) bundleData.queryParam = param;
    return bundleData;
  }

  /**
   * Check for coupon key in url
   */
  checkUrlCouponKey() {
    var urlParams = url.getUrlParams() || {};
    var coupon = urlParams["coupon"] || false;

    if (coupon) {
      this.cofs
        .validateCoupon(coupon)
        .then((result) => {
          this.coupon = coupon;
          this.renderCouponValidateMessage(result);
        })
        .catch((result) => {
          this.renderCouponValidateMessage(result);
        });
    }
  }

  /**
   * Check for selected products in local storage
   */
  checkStorageProductKeys() {
    var storedProducts = JSON.parse(
      storage.getLocalStorage(this.PRODUCTS_STORAGE_KEY)
    );

    this.assignSelectedProducts(storedProducts);
  }

  /**
   * Show password strength indicator to user
   */
  renderPasswordStrength(score) {
    var labels = {
      passwordstrength: "Password Strength",
      passwordstrengthScores: ["Weak", "Weak", "Good", "Strong", "Very Strong"],
    };

    score = this.passwordField.val().length ? score : -1;

    // Don't render password strength for invalid passwords
    if (this.passwordField.hasClass(this.ERROR_CLASS)) {
      score = -1;
    }

    var tmp = _.template(
      $(".template__form--product-on-demand--passwordstrength").html()
    );
    this.passwordScoreTemplateTarget.html(
      tmp({
        score: score,
        labels: labels,
      })
    );
  }

  /**
   * update ui with coupon messaging
   */
  renderCouponValidateMessage(result) {
    const tmp = _.template(
      $(".template__form--product-on-demand--coupon-messaging").html()
    );
    const messageSuccess =
      this.labels.informMessageCouponSuccess || "Coupon success";
    const messageError =
      this.labels.informMessageCouponError || "Coupon unavailable";
    const message = result.success ? messageSuccess : messageError;

    if (result.success && this.labels.labelSubmitCoupon) {
      this.submitButton.text(this.labels.labelSubmitCoupon);
    }

    $(".heading--products")
      .parent()
      .prepend(
        tmp({
          classResult: result.success ? "message--success" : "message--warning",
          message: message,
        })
      );
  }

  /**
   * update ui with product data for each selected product
   */
  renderProductSelections() {
    var self = this;

    // Only hide annual subscription content if user signs up for Bitbucket only
    if (
      this.selectedProducts.length === 0 &&
      this.selectedAddons.length === 1 &&
      this.selectedAddons[0].name === "Bitbucket"
    ) {
      this.annualSubscriptionContent.hide();
    }

    // Render Eula Text based on product selections
    let eulaLabel = this.labels.eulaText;
    if (!this.params.products && this.hamlet.hasAddons()) {
      eulaLabel = this.labels.eulaWithAddonsText || eulaLabel;
      this.eulaContainer.html(eulaLabel);
    }

    // Experiment for 'wcf-459' & Premium
    if (!this.useAlternateLayout) {
      // Add indicator to what products are being signed up
      _.each(this.selectedProducts, function (product) {
        var checkedElement = $(
          '<li class="form-enabled-product">' +
          (product.name || product.productDescription) +
          "</li>"
        );
        self.cofsListContainer.append(checkedElement);
      });
    } else {
      const logos = $(".trial-info-data__logos", this.$domRoot).clone();
      const editionText = $(
        ".trial-info-data__edition-text",
        this.$domRoot
      ).clone();
      logos.insertAfter(this.cofsListContainer);
      editionText.insertAfter(logos);
    }
    // (End) Experiment for 'wcf-459' & Premium

    // Add indicator to what products are being signed up
    _.each(this.hamletAddonProducts, function (product) {
      var checkedElement = $(
        '<li class="form-enabled-product">' +
        (product.name || product.productDescription) +
        "</li>"
      );
      self.cofsListContainer.append(checkedElement);
    });

    // Show indicator to what products are being signed up
    if (this.params.showFormEnabledProducts) {
      self.cofsListContainer.addClass("active");
    }

    var productsTemplateTarget = $(".imkt__list--product-on-demand");
    var template = $(".template__list--product-on-demand");

    if (!self.selectedProducts.length) {
      productsTemplateTarget = $(".imkt--cloud-signup__form");
      template = $(".template__list--product-all-external");
    }

    if (!productsTemplateTarget.length || !template.length) {
      return;
    }

    var productsTemplate = _.template(template.html());
    productsTemplateTarget.html(
      productsTemplate({
        selectedProducts: this.selectedProducts,
        selectedAddons: this.selectedAddons,
        labels: this.labels,
        isPremiumEdition: this.edition === "premium",
      })
    );
  }

  renderMarketingConsent(requiresCheckbox, label) {
    if (this.params.useGDPR) {
      var marketingLabel = $(`<label></label>`);
      var marketingConsentInput = $(
        '<input type="checkbox" name="marketing_consent" id="marketing_consent" />'
      );

      if (!requiresCheckbox) {
        marketingConsentInput.prop("checked", true);
        this.marketingConsentContainer.hide();
      } else {
        this.marketingConsentContainer.show();
      }

      marketingLabel.append(marketingConsentInput).append(label);
      this.marketingConsentContainer.append(marketingLabel);
    }
  }

  disableSubmitButton(preventSubmitActionText) {
    // Submit button may be disabled to prevent submitting
    if (!preventSubmitActionText) {
      this.submitButton.find(".submit--initial-text").hide();
      this.submitButton.find(".submit--processing-text").show();
    }

    this.submitButton.attr("disabled", "disabled");
  }

  enableSubmitButton() {
    this.submitButton.find(".submit--initial-text").show();
    this.submitButton.find(".submit--processing-text").hide();
    this.submitButton.removeAttr("disabled");
  }

  disableSubmitButtonSimplified() {
    $(
      ".imkt--cloud-signup__form--simplified .imkt--cloud-signup__button--submit"
    ).attr("disabled", "disabled");
  }

  enableSubmitButtonSimplified() {
    $(
      ".imkt--cloud-signup__form--simplified .imkt--cloud-signup__button--submit"
    ).removeAttr("disabled");
  }

  /**
   * Analytics track event for adding products configured on load / legacy reporting
   */
  trackAnalyticsProduct(i, action, callback) {
    var products = self.productKeys;

    if (products && i < products.length) {
      Tracking.trackAll(
        "cart-cloud",
        action,
        `${products[i]}.cloud`,
        {},
        false
      );
    }

    if (callback) {
      callback();
    }
  }

  /**
   * Popup external signup window as reminder for users
   */
  popupReminderExternalProducts() {
    var windowProperties = {
      top: 0,
      left: 0,
      width: 600,
      height: 400,
    };

    if (!this.selectedAddons.length) {
      return;
    }

    var addonKeys = this.selectedAddons.map(function (product) {
      return product.product_key;
    });

    var urlParams = "?product=" + addonKeys.join(",");
    var externalSignupUrl =
      this.baseDomain + this.params.externalSignupPage + urlParams;
    window.open(
      externalSignupUrl,
      "Additional Signup",
      "top=" +
      windowProperties.top +
      ",left=" +
      windowProperties.left +
      ",width=" +
      windowProperties.width +
      ",height=" +
      windowProperties.height
    );
  }

  /**
   * Toggle password field to show/hide text
   */
  togglePasswordShow() {
    if (this.showPasswordField.is(":checked")) {
      this.passwordField.attr("type", "text");
    } else {
      this.passwordField.attr("type", "password");
    }
  }

  trackOnSubmitEvents() {
    this.growthTracker.sendTrackSubmitCounter("bxp_repeat_submit");
    this.growthTracker.sendTrack("signupPressedSubmit", {
      hostname: this.accountNameField.val(),
      edition: this.edition || "",
    });
    this.hamlet.isLoggedIn()
      ? this.growthTracker.sendTrack("submit.loggedin")
      : this.growthTracker.sendTrack("submit.notloggedin");
  }

  getLocaleParam() {
    const urlParams = url.getUrlParams() || {};
    const langParam = urlParams["lang"] || false;

    if (langParam) {
      return langParam;
    }
    return;
  }

  updateLocaleText() {
    const locale = this.getLocaleParam();

    if (!locale) {
      return;
    }

    const localizedLabels = this.params.i18nLabels[locale];
    if (!localizedLabels) {
      return;
    }

    Object.assign(this.labels, localizedLabels.labels);
    this.consentLabelMarketing =
      localizedLabels.consentLabelMarketing || this.consentLabelMarketing;

    if (localizedLabels.bundleData) {
      _.each(this.bundleData, (bundle, bundleKey) => {
        Object.assign(
          this.bundleData[bundleKey],
          localizedLabels.bundleData[bundleKey]
        );
      });
    }

    const localElements = this.form.find(".translate");
    _.each(localElements, (element) => {
      const translationKey = $(element).attr("data-translate-key");
      const translation = localizedLabels.labels[translationKey];

      const translationAttr = $(element).attr("data-translate-attr");

      if (translation && translationAttr) {
        $(element).attr(translationAttr, translation);
      } else if (translation) {
        $(element).html(translation);
      }
    });
  }

  // Check the browser url for a known templateId param
  // to be passed into COFS and Cloud Provisioning for on-boarding purposes
  getTemplateFromUrl() {
    const urlParams = url.getUrlParams() || {};
    const templateParam = urlParams.templateId || false;

    return templateParam;
  }

  renderN2EModal() {
    const mySites = this.hamlet.getSites();
    const existingTargetSites = this.findSitesWithProductKey(
      mySites,
      "jira-software.ondemand"
    );

    const urlParams = url.getUrlParams() || {};
    const templateParam = urlParams.userstate || "jsw";

    if (existingTargetSites.length) {
      var tmp = _.template(
        $(`.template--cloud-signup__form--n2emodal--${templateParam}`).html()
      );
      $("body").append(
        tmp({
          existingTargetSites: existingTargetSites,
        })
      );
      $("#modal-dismiss-button").on("click", () =>
        $("#signup-bitbucket-jira > div.overlay.in").remove()
      );
    }
  }

  findSitesWithProductKey(sites, productKey) {
    return sites.filter((site) => site.products.includes(productKey));
  }

  getOpsgenieInitialProductURL() {
    const dataRegionValue = this.dataRegionField.filter(":checked").val();

    var initialProductURL = "atlassian-app.opsgenie.com";

    if (dataRegionValue == "main") {
      initialProductURL = "atlassian-app.opsgenie.com";
      if (!Environment.isProduction()) {
        initialProductURL = "atlassian-app.opsgeni.us";
      }
    } else if (dataRegionValue == "europe") {
      initialProductURL = "atlassian-app.eu.opsgenie.com";
      if (!Environment.isProduction()) {
        initialProductURL = "atlassian-app.opsgeni.us";
      }
    }

    return initialProductURL;
  }

  getOpsgenieSiteHostName() {
    const dataRegionValue = this.dataRegionField.filter(":checked").val();

    var siteHost = ".atlassian-app.opsgenie.com";

    if (dataRegionValue == "main") {
      siteHost = ".atlassian-app.opsgenie.com";
      if (!Environment.isProduction()) {
        siteHost = ".atlassian-app.opsgeni.us";
      }
    } else if (dataRegionValue == "europe") {
      siteHost = ".atlassian-app.eu.opsgenie.com";
      if (!Environment.isProduction()) {
        siteHost = ".atlassian-app.opsgeni.us";
      }
    }

    return siteHost;
  }

  getOpsgenieSiteRedirectURL() {
    const accountName = this.accountNameField.val();
    const opsgenieHostName = this.getOpsgenieSiteHostName();

    return "https://" + accountName + opsgenieHostName;
  }
}
